import React from 'react';
import "./CollapseButton.scss";
import arrow from '../../Components/Shared/Buttons/images/arrow.svg';
const CollapseButton = ({ cardTitle, setIsOpen, isOpen, icon = arrow }) => {
    const iconArrow = isOpen ? "iconArrowUp" : "iconArrowDown";

    return (
        <button className="collapse-button" onClick={() => setIsOpen(!isOpen)}>
            <label className="collapse-button__label">{cardTitle}</label>
            <div className={`collapse-button__icon ${iconArrow}`} style={{ backgroundImage: icon.bg() }}></div>
        </button>
    );
}

export default CollapseButton;